import React from "react";
import { MDBContainer, MDBTypo } from "mdbreact";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";
import { Typography } from "@material-ui/core";

import Layout from "../components/Layout";
import LightboxPage from "../components/LightboxPage";
import ColourImage from "../components/ColourImage";

import text from "../text/text.json";

import musician from "../images//headers/MusicHeader.jpg";
import musicianSIDE1 from "../images/MUS_WEBSITE_IMAGES/musicianSIDE1.JPG";
import musicianSIDE2 from "../images/MUS_WEBSITE_IMAGES/musicianSIDE2.jpg";
import musicianSIDE3 from "../images/MUS_WEBSITE_IMAGES/musicianSIDE3.jpg";

const photos = [
    {
        src: musicianSIDE1,
        width: 4,
        height: 3
    },
    {
        src: musicianSIDE2,
        width: 1,
        height: 1
    },
    {
        src: musicianSIDE3,
        width: 4,
        height: 3
    }
];

function Musician() {
  return (
    <>
      <Helmet>
        <title>Artistic Wizard | Musician</title>
      </Helmet>
      <Layout>
        <ColourImage text="" overlay="" image={musician} />
        <MDBContainer style={{ padding: "20px" }}>
          <ReactMarkdown>{text.musician.header1}</ReactMarkdown>
          <ReactMarkdown>{text.musician.body1}</ReactMarkdown>
          <ReactMarkdown>{text.musician.body2}</ReactMarkdown>
          <ReactMarkdown>{text.musician.header2}</ReactMarkdown>
          <ReactMarkdown>{text.musician.body3}</ReactMarkdown>
          <ReactMarkdown>{text.musician.body4}</ReactMarkdown>
          <MDBTypo>
            <a href="https://www.reverbnation.com/artist/artisticwizard">ReverbNation.com/artist/artisticwizard</a>
          </MDBTypo>
          <MDBTypo>
            <a href="https://www.triplejunearthed.com/artist/darren-conway">TripleJUnearthed.com/artist/darren-conway</a>
          </MDBTypo>
          <br />
          <LightboxPage images={photos} />
        </MDBContainer>
      </Layout>
    </>
  )
}

export default Musician;